var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatchPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04169 5.83366H13.9584V4.16699C13.9584 2.50033 13.3334 1.66699 11.4584 1.66699H8.54169C6.66669 1.66699 6.04169 2.50033 6.04169 4.16699V5.83366Z",
    stroke: "#768D89",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 12.5V15.8333C13.3334 17.5 12.5 18.3333 10.8334 18.3333H9.16669C7.50002 18.3333 6.66669 17.5 6.66669 15.8333V12.5H13.3334Z",
    stroke: "#768D89",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.33301V12.4997C17.5 14.1663 16.6667 14.9997 15 14.9997H13.3333V12.4997H6.66667V14.9997H5C3.33333 14.9997 2.5 14.1663 2.5 12.4997V8.33301C2.5 6.66634 3.33333 5.83301 5 5.83301H15C16.6667 5.83301 17.5 6.66634 17.5 8.33301Z",
    stroke: "#768D89",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 12.5H13.1583H5.83331",
    stroke: "#768D89",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 9.16699H8.33331",
    stroke: "#768D89",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchPrinter);
export default __webpack_public_path__ + "static/media/batch_printer.61b649a72ef7c27690fee87718831fc7.svg";
export { ForwardRef as ReactComponent };